export default "__VITE_ASSET__BEM7E7NP__"